import { type AvatarColor, DEFAULT_AVATAR_COLORS } from '@/features/user/hooks/avatarColors';

export const ColorSelector = ({
  selectedColorId,
  currentColorId,
  onColorSelect,
  availableColors = DEFAULT_AVATAR_COLORS,
  className = '',
}: {
  selectedColorId?: string | number;
  currentColorId?: string | number;
  onColorSelect: (colorId: string) => void;
  availableColors?: AvatarColor[];
  className?: string;
}) => {
  const handleColorClick = (colorId: string) => {
    // Direct optimistic update - no events needed
    onColorSelect(colorId);
  };

  return (
    <div className={`flex gap-2 flex-wrap ${className}`}>
      {availableColors.map((color) => {
        const isSelected = selectedColorId && selectedColorId === color.id;
        const isCurrent = !selectedColorId && currentColorId && currentColorId === color.id;
        const isActive = isSelected || isCurrent;

        return (
          <button
            className={`w-7 h-7 rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-primary-gold focus:ring-offset-1 ${
              isActive ? 'scale-75' : 'hover:scale-110'
            }`}
            key={color.id}
            style={{ backgroundColor: color.value }}
            type="button"
            onClick={() => handleColorClick(String(color.id))}
          />
        );
      })}
    </div>
  );
};
